"use client";
import React, { useState } from "react";
import { Sun, Plus, Minus } from "lucide-react";
import { faqs } from "../data/faqsData";
import { motion, AnimatePresence } from "framer-motion";

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const halfLength = Math.ceil(faqs.length / 2);
  const firstHalf = faqs.slice(0, halfLength);
  const secondHalf = faqs.slice(halfLength);

  return (
    <div className="flex flex-col py-[4rem] px-[1.5rem] sm:px-[3rem] lg:px-[6rem] gap-4">
      <div className="flex flex-col gap-3 mb-8">
        <div className="text-pri text-desc-size2 flex items-center gap-2">
          <Sun size={20} />
          <span>FAQs</span>
        </div>
        <div className="text-text1 text-title-size3 lg:text-title-size2 md:w-[60vw] leading-[1]">
          Frequently Asked Questions
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-14 ">
        {/* First Column */}
        <div className="flex flex-col gap-6">
          {firstHalf.map((faq, index) => (
            <div
              key={index}
              className="border-b border-tert pb-4 cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center gap-1">
                <div
                  className={`text-[1.2rem] font-semibold ${
                    openIndex === index ? "text-pri" : "text-color1"
                  }`}
                >
                  {faq.question}
                </div>
                <div className="text-pri">
                  {openIndex === index ? (
                    <Minus size={20} />
                  ) : (
                    <Plus size={20} className="text-color1" />
                  )}
                </div>
              </div>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="mt-2 text-color3 text-[1rem]"
                  >
                    {faq.answer}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        {/* Second Column */}
        <div className="flex flex-col gap-6">
          {secondHalf.map((faq, index) => (
            <div
              key={index + halfLength}
              className="border-b border-tert pb-4 cursor-pointer"
              onClick={() => toggleFAQ(index + halfLength)}
            >
              <div className="flex justify-between items-center">
                <div
                  className={`text-[1.2rem] font-semibold ${
                    openIndex === index + halfLength
                      ? "text-pri"
                      : "text-color1"
                  }`}
                >
                  {faq.question}
                </div>
                <div className="text-pri">
                  {openIndex === index + halfLength ? (
                    <Minus size={20} />
                  ) : (
                    <Plus size={20} className="text-color1" />
                  )}
                </div>
              </div>
              <AnimatePresence>
                {openIndex === index + halfLength && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="mt-2 text-color3 text-[1rem]"
                  >
                    {faq.answer}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqs;
